<template>
  <div class="swiper_warp">
    <swiper :options="swiperOption">
      <swiper-slide><img
          class="swiper_slide"
          src="http://test.00800.com.cn/pc/banner_1.jpg"
        /></swiper-slide>
      <!-- <swiper-slide><img
          class="swiper_slide"
          src="http://www.00800.com.cn/cnhs/wqproject/storage/app/public/PCNew/common/img/bg2.jpg"
        /></swiper-slide>
      <swiper-slide><img
          class="swiper_slide"
          src="http://www.00800.com.cn/cnhs/wqproject/storage/app/public/PCNew/common/img/bg2.jpg"
        /></swiper-slide>
      <swiper-slide><img
          class="swiper_slide"
         src="http://www.00800.com.cn/cnhs/wqproject/storage/app/public/PCNew/common/img/bg2.jpg"
        /></swiper-slide>
      <swiper-slide><img
          class="swiper_slide"
          src="http://www.00800.com.cn/cnhs/wqproject/storage/app/public/PCNew/common/img/bg2.jpg"
        /></swiper-slide>
      <div
        class="swiper-pagination"
        slot="pagination"
      ></div> -->
    </swiper>
  </div>
  <!-- <div class="huge-screen" :style="styleObject">
  </div> -->
</template>
<script>
// import { getHugeInfo } from '@/api/picSetting'
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      styleObject: {
        background: '',
        backgroundPosition: 'center!important'
      },
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        }
      }
    }
  },
  created() {
    // getHugeInfo().then(response=>{
    //   this.styleObject.background = `url("${response.data.huge_img}")`
    //   this.styleObject.backgroundPosition = 'center'
    // })
  }

}
</script>
<style lang="scss">
.swiper_warp {
  width: 100%;
  .swiper_slide {
    height: 460px;
    width: 100%;
  }
}
.huge-screen {
  height: 320px;
  background: url("http://192.168.101.110/pc/pc/index/img/banner_1.jpg");
  overflow: hidden;
  background-position: center;
  margin-bottom: 20px;
}
</style>
